import { useI18n } from "#hooks/use-i18n"
import { Plus, Upload } from "lucide-react"
import { Button } from "../ui/button"
import { Tooltip, TooltipContent, TooltipTrigger } from "../ui/tooltip"

interface ExpensesHeaderActionsProps {
  onAddExpense: () => void
  onImportCSV: () => void
  isOwner: boolean
}

export function ExpensesHeaderActions({
  onAddExpense,
  onImportCSV,
  isOwner,
}: ExpensesHeaderActionsProps) {
  const { t } = useI18n()

  return (
    <div className="flex gap-2 w-full sm:w-auto">
      {isOwner ? (
        <>
          <Button
            onClick={onImportCSV}
            variant="outline"
            className="shadow-sm dark:shadow-none dark:border-border/50 hover:shadow-md dark:hover:shadow-none transition-shadow"
          >
            <Upload className="w-5 h-5 mr-2" />
            {t("components.expenseImport.importCsvButton")}
          </Button>
          <Button
            onClick={onAddExpense}
            className="shadow-sm dark:shadow-none dark:border-border/50 hover:shadow-md dark:hover:shadow-none transition-shadow"
          >
            <Plus className="w-5 h-5 mr-2" />
            {t("components.expenseImport.addExpenseButton")}
          </Button>
        </>
      ) : (
        <>
          <Tooltip>
            <TooltipTrigger asChild>
              <span>
                <Button
                  variant="outline"
                  disabled
                  className="shadow-sm dark:shadow-none dark:border-border/50"
                >
                  <Upload className="w-5 h-5 mr-2" />
                  {t("components.expenseImport.importCsvButton")}
                </Button>
              </span>
            </TooltipTrigger>
            <TooltipContent>
              <p>{t("components.expenses.tooltips.actionDisabled")}</p>
            </TooltipContent>
          </Tooltip>
          <Tooltip>
            <TooltipTrigger asChild>
              <span>
                <Button disabled className="shadow-sm dark:shadow-none dark:border-border/50">
                  <Plus className="w-5 h-5 mr-2" />
                  {t("components.expenseImport.addExpenseButton")}
                </Button>
              </span>
            </TooltipTrigger>
            <TooltipContent>
              <p>{t("components.expenses.tooltips.actionDisabled")}</p>
            </TooltipContent>
          </Tooltip>
        </>
      )}
    </div>
  )
}
